import React, { createContext, useState, useContext } from 'react';
import { Snackbar, Alert } from '@mui/material';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);

    const showToast = (message, severity = 'info') => {
        const id = Date.now() + Math.random();

        setToasts(prev => [
            ...prev,
            { id, message, severity }
        ]);
    };

    const hideToast = (id) => {
        setToasts(prev => prev.filter(toast => toast.id !== id));
    };

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}

            {toasts.map((toast, index) => (
                <Snackbar
                    key={toast.id}
                    open
                    autoHideDuration={6000}
                    onClose={() => hideToast(toast.id)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    sx={{
                        mt: `${index * 70}px`, // stack below previous toast
                    }}
                >
                    <Alert
                        onClose={() => hideToast(toast.id)}
                        severity={toast.severity}
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {toast.message}
                    </Alert>
                </Snackbar>
            ))}
        </ToastContext.Provider>
    );
};

export const useToast = () => useContext(ToastContext);